import React from 'react';
import { useQueryClient, useMutation } from '@tanstack/react-query';

import { FeedbackContext, LocalizationContext } from '@cvt/contexts';
import { cacheKeys } from '@modules/Feedback/config';
import { cacheKeys as meetingCacheKeys }  from '@modules/Meetings/config';
import { feedbackClient } from '@modules/Feedback/client/feedbackClient';



export const useFeedbackCrud = () => {
  const { dictionary } = React.useContext(LocalizationContext);
  const { triggerFeedback, genericErrorFeedback } = React.useContext(FeedbackContext);
  const queryClient = useQueryClient();

  const createFeedback = useMutation({
    mutationKey: [cacheKeys.createFeedback],
    mutationFn: feedbackClient.createFeedback,
    onSuccess: (data, variables) => {
      const { meetingId } = variables;
      queryClient.invalidateQueries({
        queryKey: [meetingCacheKeys.getMeetings],
      });
      queryClient.invalidateQueries({
        queryKey: [meetingCacheKeys.getMeeting, meetingId],

      });
      triggerFeedback({
        severity: 'success',
        message: dictionary.feedback.changesSaved,
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  const editFeedback = useMutation({
    mutationKey: [cacheKeys.editFeedback],
    mutationFn: ({ id, ...data }: Partial<Feedback.Edit>) => feedbackClient.editFeedback({ id, ...data }),
    onSuccess: (data, variables) => {
      const { meetingId } = variables;
      queryClient.invalidateQueries({
        queryKey: [meetingCacheKeys.getMeetings],
      });
      queryClient.invalidateQueries({
        queryKey: [meetingCacheKeys.getMeeting, meetingId],
        exact: true,
      });
      triggerFeedback({
        severity: 'success',
        message: dictionary.feedback.changesSaved,
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });


  return {
    createFeedback,
    editFeedback,
  };
};
